import { datadogRum } from '@datadog/browser-rum';
import { boundContext } from '@ringba/core/telemetry';
import { isRumActive, logger } from './state';

/**
 * Sends `error` to RUM with a size-bounded `context`.
 *
 * Never throws:
 * - No-op when RUM is not active.
 * - An SDK failure is logged and swallowed.
 */
export function reportError(error: unknown, context?: object): void {
  if (!isRumActive()) {
    return;
  }

  try {
    datadogRum.addError(error, boundContext(context) as object | undefined);
  } catch (err) {
    logger.warn('Failed to report error to RUM', err);
  }
}
